import { FC, Fragment, ReactNode } from 'react'
import { CategoryState, SideoverState } from '@/states'
import { Clipboard, File, Input, Select, Tags } from '@/ui/views'
import { DocumentArrowUpIcon, VideoCameraIcon } from '@heroicons/react/16/solid'

import {
    CategoryValidation,
    ImageValidation,
    LinkValidation,
    NameValidation,
    PriceValidation,
    VideoValidation
} from '@/helpers'

const ComponentForm: FC = (): ReactNode => {
    const {
        Open,
        SetState,
        Form,
        Errors,
        Loading
    } = SideoverState()

    const { Categories } = CategoryState()

    const HandleChange = (value: string, target: keyof ComponentFormInterface & keyof ComponentErrorInterface) => {
        if (Open && !Loading) {
            const form = structuredClone(Form)
            const errors = structuredClone(Errors)

            form[target] = value
            errors[target] = true

            SetState({
                Form: form,
                Errors: errors
            })
        }
    }

    return (
        <Fragment>
            <Input
                target='Name'
                label='Name'
                placeholder='Component Name'
                required={true}
                value={Form?.Name}
                id='Component'
                // @ts-ignore
                onChange={HandleChange}
                showError={Errors?.Name}
                validationFunction={NameValidation}
                disabled={Loading}
            />

            <Input
                target='Price'
                label='Price (0 means free)'
                placeholder='0'
                type='number'
                required={true}
                value={Form?.Price}
                id='price'
                // @ts-ignore
                onChange={HandleChange}
                showError={Errors?.Price}
                validationFunction={PriceValidation}
                disabled={Loading}
            />

            <Select
                target='Category'
                label='Category'
                placeholder='Select Category'
                required={true}
                value={Form?.Category}
                id='category'
                // @ts-ignore
                onChange={HandleChange}
                showError={Errors?.Category}
                validationFunction={CategoryValidation}
                list={Categories}
                idAccessor='_id'
                valueAccessor='Name'
                disabled={Loading}
            />

            <Tags />

            <Input
                target='Link'
                label='Link'
                placeholder='https://webflow.com/...'
                required={false}
                value={Form?.Link}
                id='link'
                // @ts-ignore
                onChange={HandleChange}
                showError={Errors?.Link}
                validationFunction={LinkValidation}
                disabled={Loading}
            />

            <File
                target='Image'
                icon={<DocumentArrowUpIcon className='flex-shrink-0 w-7 h-7 text-[#EBEBEB]' />}
                label='Image Preview'
                required={true}
                validationFunction={ImageValidation}
            />

            <File
                target='Video'
                icon={<VideoCameraIcon className='flex-shrink-0 w-7 h-7 text-[#EBEBEB]' />}
                label='Video Preview'
                required={true}
                validationFunction={VideoValidation}
            />

            <Clipboard />
        </Fragment>
    )
}

export default ComponentForm
